export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg className={className} viewBox="0 0 40 40" fill="none" aria-hidden="true">
    <rect width="40" height="40" rx="11" fill="#0D6EFD" />
    <path d="M13 30V20.5C13 16.4 16.1 13 20 13C23.9 13 27 16.4 27 20.5V30" stroke="white" strokeWidth="3.4" strokeLinecap="round" />
    <path d="M13 20.5C13 16.5 9.5 15.5 8 17.5C6.6 19.4 8.2 22.4 11 21.6" stroke="white" strokeWidth="2.8" strokeLinecap="round" />
    <path d="M27 20.5C27 16.5 30.5 15.5 32 17.5C33.4 19.4 31.8 22.4 29 21.6" stroke="white" strokeWidth="2.8" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark />
    <span className={`font-display text-lg font-extrabold leading-none tracking-tight ${dark ? "text-white" : "text-[#0B132B]"}`}>
      Aries<span className="text-[#0D6EFD]">.</span>
      <span className={`block text-[11px] font-medium tracking-[0.18em] uppercase ${dark ? "text-slate-300" : "text-slate-500"}`}>App Station</span>
    </span>
  </span>
);
